import React, { useMemo } from 'react';
import { Box, Inscription } from '@common-fe/common-fe';
import { capitalize } from 'lodash';
import styled from 'styled-components';

import regexp from '@/common/regexp';

const Wrapper = styled(Box)`
  &:not(:first-child) {
    margin-top: ${({ theme }) => theme.spacings.spacing12};
  }
`;

export const ListItem = styled(Box)`
  position: relative;
  &:before {
    content: '';
    position: absolute;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.canvas};
    left: 5px;
    top: 7px;
  }
`;

export interface ItemNameId {
  id?: string;
  name?: string;
  categoryType?: string;
}

export interface CategorizedItems {
  [key: string]: ItemNameId[];
}

export interface ItemNameId {
  id?: string;
  name?: string;
  categoryType?: string;
}

export const categorizeServices = (services: ItemNameId[]) => services.reduce((acc, val) => {
  if (!val?.categoryType) return acc;

  if (!acc[val.categoryType]) {
    acc[val.categoryType] = [];
  }

  acc[val.categoryType].push(val);

  return acc;
}, {} as CategorizedItems);

export interface CategorizedItem {
  name?: string;
  categoryType?: string;
}

interface Props {
  categorizedItems: CategorizedItem[];
}

const CategorizedHint: React.FC<Props> = ({ categorizedItems }) => {
  const categories = useMemo(() => categorizeServices(categorizedItems), [categorizedItems]);

  return (
    <Box
      data-testId="categorized_hint"
      height={{ max: '200px' }}
      width={{ max: '250px' }}
      overflow={{ vertical: 'auto' }}
      style={{ display: 'block' }}
    >
      {Object.keys(categories).map((category) => (
        <Wrapper data-testId={`hint_category_${category}`} key={category}>
          <Inscription color="canvas" weight="bold" size="12px" margin={{ bottom: 'spacing4' }}>
            {capitalize(category)?.replace(regexp.DASH_SYMBOL, ' ')}
          </Inscription>
          {categories[category]?.map((item) => (
            <ListItem
              key={item?.name}
              pad={{ left: 'spacing16' }}
            >
              <Inscription
                size="12px"
                color="textOnColor"
              >
                {item?.name}
              </Inscription>
            </ListItem>
          ))}
        </Wrapper>
      ))}
    </Box>
  );
};

export default CategorizedHint;
